var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
const DEFAULT_MAX = 10;
const safeParse = (str) => {
    if (!str) {
        return null;
    }
    try {
        return JSON.parse(str);
    }
    catch (ex) {
        return null;
    }
};
const generateRandomID = () => {
    try {
        return window.crypto.randomUUID();
    }
    catch (ex) {
        return `palette-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    }
};
const add = (color, oldList, max = DEFAULT_MAX) => {
    const list = oldList.slice();
    const idx = list.indexOf(color);
    if (idx !== -1) {
        list.splice(idx, 1);
    }
    list.unshift(color);
    return list.slice(0, max);
};
class ColorListStorage {
    constructor(key = '', max = DEFAULT_MAX) {
        this.key = key;
        this.max = max;
    }
    load() {
        if (this.key) {
            return safeParse(localStorage.getItem(this.key)) || [];
        }
        return [];
    }
    store(list) {
        if (this.key) {
            localStorage.setItem(this.key, JSON.stringify(list));
        }
    }
    add(color) {
        const list = add(color, this.load(), this.max);
        this.store(list);
    }
    clean() {
        this.store([]);
    }
}
// from google docs
const grayList = JSON.parse(`[
["#000000", "黑色"      ], ["#434343", "深灰色 4"  ], ["#666666", "深灰色 3"  ], ["#999999", "深灰色 2"  ], ["#b7b7b7", "深灰色 1"  ], ["#cccccc", "灰色"      ], ["#d9d9d9", "浅灰色 1"  ], ["#efefef", "浅灰色 2", true], ["#f3f3f3", "浅灰色 3", true], ["#ffffff", "白色", true]
]`);
const colorList = JSON.parse(`[
["#980000", "浆果红"    ], ["#ff0000", "红色"      ], ["#ff9900", "橙色"      ], ["#ffff00", "黄色"      ], ["#00ff00", "绿色"      ], ["#00ffff", "青色"      ], ["#4a86e8", "矢车菊蓝"  ], ["#0000ff", "蓝色"      ], ["#9900ff", "紫色"      ], ["#ff00ff", "洋红色"    ],
["#e6b8af", "浅浆果红色 3"], ["#f4cccc", "浅红色 3"  ], ["#fce5cd", "浅橙色 3"  ], ["#fff2cc", "浅黄色 3"  ], ["#d9ead3", "浅绿色 3"  ], ["#d0e0e3", "浅青色 3"  ], ["#c9daf8", "浅矢车菊蓝色 3"], ["#cfe2f3", "浅蓝色 3"  ], ["#d9d2e9", "浅紫色 3"  ], ["#ead1dc", "浅洋红色 3"],
["#dd7e6b", "浅浆果红色 2"], ["#ea9999", "浅红色 2"  ], ["#f9cb9c", "浅橙色 2"  ], ["#ffe599", "浅黄色 2"  ], ["#b6d7a8", "浅绿色 2"  ], ["#a2c4c9", "浅青色 2"  ], ["#a4c2f4", "浅矢车菊蓝色 2"], ["#9fc5e8", "浅蓝色 2"  ], ["#b4a7d6", "浅紫色 2"  ], ["#d5a6bd", "浅洋红色 2"],
["#cc4125", "浅浆果红色 1"], ["#e06666", "浅红色 1"  ], ["#f6b26b", "浅橙色 1"  ], ["#ffd966", "浅黄色 1"  ], ["#93c47d", "浅绿色 1"  ], ["#76a5af", "浅青色 1"  ], ["#6d9eeb", "浅矢车菊蓝色 1"], ["#6fa8dc", "浅蓝色 1"  ], ["#8e7cc3", "浅紫色 1"  ], ["#c27ba0", "浅洋红色 1"],
["#a61c00", "深浆果红色 1"], ["#cc0000", "深红色 1"  ], ["#e69138", "深橙色 1"  ], ["#f1c232", "深黄色 1"  ], ["#6aa84f", "深绿色 1"  ], ["#45818e", "深青色 1"  ], ["#3c78d8", "深矢车菊蓝色 1"], ["#3d85c6", "深蓝色 1"  ], ["#674ea7", "深紫色 1"  ], ["#a64d79", "深洋红色 1"],
["#85200c", "深浆果红色 2"], ["#990000", "深红色 2"  ], ["#b45f06", "深橙色 2"  ], ["#bf9000", "深黄色 2"  ], ["#38761d", "深绿色 2"  ], ["#134f5c", "深青色 2"  ], ["#1155cc", "深矢车菊蓝色 2"], ["#0b5394", "深蓝色 2"  ], ["#351c75", "深紫色 2"  ], ["#741b47", "深洋红色 2"],
["#5b0f00", "深浆果红色 3"], ["#660000", "深红色 3"  ], ["#783f04", "深橙色 3"  ], ["#7f6000", "深黄色 3"  ], ["#274e13", "深绿色 3"  ], ["#0c343d", "深青色 3"  ], ["#1c4587", "深矢车菊蓝色 3"], ["#073763", "深蓝色 3"  ], ["#20124d", "深紫色 3"  ], ["#4c1130", "深洋红色 3"]
]`);
const isHex = (text) => /^[0-9a-f]+$/i.test(text);
let ExEditorColorHexInputElement = class ExEditorColorHexInputElement extends LitElement {
    constructor() {
        super(...arguments);
        this.text = '';
    }
    attributeChangedCallback(name, oldValue, value) {
        super.attributeChangedCallback(name, oldValue, value);
        if (name === 'value' && typeof value === 'string') {
            if (value === '') {
                this.text = '';
                if (this.input) {
                    this.input.value = '';
                }
            }
            else if (value.charAt(0) === '#') {
                this.text = value.slice(1);
                this.input.value = this.text;
            }
        }
    }
    render() {
        return html `
      <input
        type="text"
        maxlength="8"
        @input=${this.handleChange}
        @click=${this.handlePreventDefault}
        @change=${this.handleChange}
      />
      <span class="prefix">#</span>
    `;
    }
    handlePreventDefault(event) {
        event.preventDefault();
    }
    handleChange(event) {
        let text = this.input.value.trim();
        if (text.charAt(0) === '#') {
            text = text.slice(1);
        }
        if (!text || isHex(text)) {
            let valid = false;
            this.text = text;
            if (!text) {
                this.value = '';
                valid = true;
            }
            else if ([3, 4, 6, 8].indexOf(text.length) !== -1) {
                this.value = '#'.concat(text);
                valid = true;
            }
            const customEvent = new CustomEvent('change', {
                detail: { value: this.value, valid },
            });
            this.dispatchEvent(customEvent);
        }
        else {
            event.preventDefault();
            this.input.value = this.text;
        }
    }
};
ExEditorColorHexInputElement.styles = [
    css `
      :host {
        position: relative;
        display: flex;
        font-size: 12px;
      }
      .prefix {
        position: absolute;
        top: 50%;
        left: 5px;
        color: #555;
        transform: translateY(-50%);
        pointer-events: none;
      }
      input {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        padding: 2px 5px 2px 15px;
        border: 1px solid #e7e7e7;
        border-radius: 4px;
        font-size: inherit;
      }
      input:focus {
        outline: none;
      }
    `,
];
__decorate([
    query('input')
], ExEditorColorHexInputElement.prototype, "input", void 0);
__decorate([
    property({
        attribute: true,
        reflect: true,
    })
], ExEditorColorHexInputElement.prototype, "value", void 0);
__decorate([
    state()
], ExEditorColorHexInputElement.prototype, "text", void 0);
ExEditorColorHexInputElement = __decorate([
    customElement('exeditor-color-hex-input')
], ExEditorColorHexInputElement);
export { ExEditorColorHexInputElement };
let ExEditorColorPaletteElement = class ExEditorColorPaletteElement extends LitElement {
    constructor() {
        super(...arguments);
        this.t = (token, fallback) => fallback !== null && fallback !== void 0 ? fallback : token;
        this.recentList = [];
        this.paletteID = generateRandomID();
        this.handleSyncRecentColor = ({ key, list, color, paletteID, }) => {
            if (key === this.key && paletteID !== this.paletteID) {
                this.recentList = list;
                this.customColor = color;
            }
        };
    }
    connectedCallback() {
        var _a;
        super.connectedCallback();
        this.recentlyUsed = new ColorListStorage(this.key);
        this.recentList = this.recentlyUsed.load();
        (_a = this.editor) === null || _a === void 0 ? void 0 : _a.on('updatePaletteRecentColor', this.handleSyncRecentColor);
    }
    disconnectedCallback() {
        var _a;
        (_a = this.editor) === null || _a === void 0 ? void 0 : _a.off('updatePaletteRecentColor', this.handleSyncRecentColor);
    }
    attributeChangedCallback(name, oldValue, value) {
        super.attributeChangedCallback(name, oldValue, value);
        if (name === 'value') {
            this.customColor = value || '';
            if (this.customInput) {
                this.customInput.value = this.customColor;
            }
        }
    }
    render() {
        const { t } = this;
        return html `
      ${this.recentList.length
            ? html `
            <div class="title">${t('最近使用')}</div>
            <ul
              class="list"
              @mousedown=${(e) => e.preventDefault()}
            >
              ${this.recentList.map((value) => html `
                  <li
                    class="item border ${classMap({
                active: value === this.value,
            })}"
                    @click=${() => this.handlePick(value)}
                    style="background: ${value}"
                  ></li>
                `)}
            </ul>
          `
            : null}

      <div class="title">${t('全部颜色')}</div>
      <ul class="list" @mousedown=${(e) => e.preventDefault()}>
        ${grayList.map(([value, label, hasBorder]) => html `
            <li
              class="item ${classMap({
            border: Boolean(hasBorder),
            active: value === this.value,
        })}"
              @click=${() => this.handlePick(value)}
              title=${t(label)}
              style="${value ? `background: ${value}` : ''}"
            ></li>
          `)}
        ${colorList.map(([value, label]) => html `
            <li
              class="item ${classMap({ active: value === this.value })}"
              @click=${() => this.handlePick(value)}
              title=${t(label)}
              style="background: ${value}"
            ></li>
          `)}
      </ul>

      <div
        class="reset-default"
        aria-label="${t('默认')}"
        @click=${() => this.handlePick('')}
      >
        ${t('恢复默认')}
      </div>

      <hr />

      <div class="custom">
        <div
          class="custom-preview"
          style="background: ${this.customColor}"
        ></div>
        <exeditor-color-hex-input
          class="custom-input"
          value=${this.customColor}
          @change=${this.updateCustomColor}
        >
        </exeditor-color-hex-input>
        <button
          role="button"
          type="button"
          class="btn custom-button"
          @click=${this.addCustomColor}
        >
          ${t('自定义')}
        </button>
      </div>
    `;
    }
    handlePick(color) {
        this.dispatchEvent(new CustomEvent('pick', { detail: color }));
        if (color) {
            this.recentlyUsed.add(color);
            this.recentList = add(color, this.recentList);
        }
        this.customColor = color;
        if (this.editor) {
            this.editor.emit('updatePaletteRecentColor', {
                key: this.key,
                color,
                list: this.recentList,
                paletteID: this.paletteID,
            });
        }
    }
    addCustomColor(event) {
        event.preventDefault();
        this.handlePick(this.customColor);
    }
    updateCustomColor(event) {
        const { valid, value } = event.detail;
        if (valid) {
            this.customColor = value.toLowerCase();
        }
    }
};
ExEditorColorPaletteElement.styles = [
    css `
      :host {
        display: block;
        padding: 12px;
      }
      .list {
        list-style: none;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin: 0;
        padding: 0;
        gap: 4px;
        width: 236px;
        color: #555;
        font-size: 12px;
        margin-bottom: 8px;
      }
      .list(:last-child) {
        margin-bottom: 12px;
      }
      .item {
        box-sizing: border-box;
        height: 20px;
        width: 20px;
        padding: 0;
        border-radius: 2px;
        position: relative;
        cursor: pointer;
      }
      .item.border {
        border: 1px solid #e7e7e7;
      }
      .item.active {
        box-shadow: 0 0 0 2px #abc;
      }
      .item:hover {
        box-shadow: 0 0 3px 1px #abc;
      }

      .title {
        font-size: 12px;
        color: #b2b2b2;
        width: 100%;
        margin-bottom: 8px;
        line-height: 1.25;
      }

      .reset-default {
        width: 100%;
        height: 30px;
        line-height: 30px;
        color: #666;
        font-size: 12px;
        text-align: center;
        border: 1px solid #e7e7e7;
        border-radius: 4px;
        margin-bottom: 11px;
      }

      .reset-default:hover {
        box-shadow: 0 0 3px 1px #abc8;
      }

      hr {
        margin: 8px 0;
        border: none;
        border-top: 1px solid #e7e7e7;
        color: #e7e7e7;
      }

      .btn {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0 none;
        border-radius: 15px;
        outline: none;
        cursor: pointer;
      }
      .custom {
        display: flex;
        align-items: center;
      }
      .custom-preview {
        box-sizing: border-box;
        display: block;
        height: 30px;
        width: 30px;
        margin-right: 10px;
        border: 1px solid #e7e7e7;
        border-radius: 2px;
      }
      .custom-input {
        box-sizing: border-box;
        flex: 1;
        height: 30px;
        margin-right: 10px;
      }
      .custom-button {
        height: 30px;
        width: 60px;
        background: none;
        background-color: #ffdb00;
        font-size: 12px;
        color: #222;
      }
    `,
];
__decorate([
    query('.custom-input')
], ExEditorColorPaletteElement.prototype, "customInput", void 0);
__decorate([
    property({
        attribute: true,
    })
], ExEditorColorPaletteElement.prototype, "editor", void 0);
__decorate([
    property({
        attribute: true,
        reflect: true,
    })
], ExEditorColorPaletteElement.prototype, "value", void 0);
__decorate([
    property({
        attribute: true,
        reflect: true,
    })
], ExEditorColorPaletteElement.prototype, "key", void 0);
__decorate([
    property()
], ExEditorColorPaletteElement.prototype, "t", void 0);
__decorate([
    state()
], ExEditorColorPaletteElement.prototype, "recentList", void 0);
__decorate([
    state()
], ExEditorColorPaletteElement.prototype, "customColor", void 0);
__decorate([
    state()
], ExEditorColorPaletteElement.prototype, "paletteID", void 0);
ExEditorColorPaletteElement = __decorate([
    customElement('exeditor-color-palette')
], ExEditorColorPaletteElement);
export { ExEditorColorPaletteElement };
//# sourceMappingURL=color-palette.js.map